export enum MutationTypes {
    SET_PHOTO = 'SET_PHOTO',
    SET_STEP = 'SET_STEP',
    SET_LOADING = 'SET_LOADING',
    SET_RETURN_URL = 'SET_RETURN_URL',
    SET_ERROR = 'SET_ERROR',
    SET_DOCUMENT = 'SET_DOCUMENT',
    SET_SESSIONTYPE = "SET_SESSIONTYPE"
}
